import { apiAction } from "store/middlewares/api.middleware.helper";
import { IState, EMethods } from "store/store.interface";
import {
  GET_PAYMENT_METHODS,
  SET_PAYMENT_METHODS,
} from "store/store.types";
import { Dispatch } from "redux";
import { staticApiEndpoints } from "constant";

export const getPaymentMethods =
  () => (dispatch: Dispatch, getState: () => IState) => {
    const {
      auth: { storeId = "" },
    } = getState();
    dispatch(
      apiAction({
        url: staticApiEndpoints.PAYMENTS,
        label: GET_PAYMENT_METHODS,
        method: EMethods.GET,
        isStatic: true,
        data: {},
        headers: {
          channel: "c4online",
          storeId,
        },
        onSuccess:
          ({ data }) =>
          (dispatch: Dispatch) =>
            dispatch({
              type: SET_PAYMENT_METHODS,
              payload: data,
            }),
      })
    );
  };

